(function () {
  function setHiddenInput(form, name, value) {
    var input = form.querySelector('input[data-pes-dynamic="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-pes-dynamic', name);
      form.appendChild(input);
    }
    input.value = value;
  }

  function removeHiddenInput(form, name) {
    var input = form.querySelector('input[data-pes-dynamic="' + name + '"]');
    if (input) input.remove();
  }

  var lightbox = null;
  var lightboxSelectHandler = null;

  function ensureLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.createElement('div');
    lightbox.className = 'pes-lightbox';
    lightbox.innerHTML =
      '<div class="pes-lightbox__inner">' +
      '<button type="button" class="pes-lightbox__close" data-lightbox-close aria-label="Close">✕</button>' +
      '<img src="" alt="">' +
      '<div class="pes-lightbox__caption"></div>' +
      '<div class="pes-lightbox__actions">' +
      '<button type="button" class="button" data-lightbox-select>Select This Design</button>' +
      '</div>' +
      '</div>';
    document.body.appendChild(lightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.hasAttribute('data-lightbox-close')) {
        closeLightbox();
      }
    });
    lightbox.querySelector('[data-lightbox-select]').addEventListener('click', function () {
      if (lightboxSelectHandler) lightboxSelectHandler();
      closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
    return lightbox;
  }

  function openLightbox(url, name, onSelect) {
    var lb = ensureLightbox();
    lb.querySelector('img').src = url;
    lb.querySelector('img').alt = name;
    lb.querySelector('.pes-lightbox__caption').textContent = name;
    lightboxSelectHandler = onSelect;
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function initLibrary(root) {
    var tabButtons = root.querySelectorAll('[data-pes-tab-btn]');
    var tabPanels = root.querySelectorAll('[data-pes-tab-panel]');
    var searchInput = root.querySelector('[data-pes-library-search]');
    var grid = root.querySelector('[data-pes-library-grid]');
    var countEl = root.querySelector('[data-pes-library-count]');
    var emptyEl = root.querySelector('[data-pes-library-empty]');
    var banner = root.querySelector('[data-pes-library-banner]');
    var bannerImg = banner ? banner.querySelector('img') : null;
    var bannerText = banner ? banner.querySelector('span') : null;
    var dataUrl = root.getAttribute('data-pes-library-json');

    var form =
      root.closest('form') ||
      (root.closest('product-form') && root.closest('product-form').querySelector('form')) ||
      document.querySelector('product-form form') ||
      document.querySelector('form[action*="/cart/add"]:not(.installment)');

    var designs = [];
    var groups = [];
    var activeTab = 'custom';
    var selected = null; // { display, url }

    function groupDesigns(list) {
      var byName = {};
      var order = [];
      list.forEach(function (item) {
        if (!byName[item.display]) {
          byName[item.display] = { display: item.display, variants: [] };
          order.push(item.display);
        }
        byName[item.display].variants.push({ size: item.size, url: item.url });
      });
      return order.map(function (name) { return byName[name]; });
    }

    function cardHtml(group, index) {
      var thumb = group.variants[0].url;
      return (
        '<div class="pes-library-card" data-card data-group-index="' + index + '">' +
        '<button type="button" class="pes-library-card__zoom" data-zoom aria-label="View larger image">⛶</button>' +
        '<img src="' + thumb + '" loading="lazy" alt="' + group.display + '">' +
        '<span class="pes-library-card__name">' + group.display + '</span>' +
        '</div>'
      );
    }

    function renderGrid(filterText) {
      var filtered = groups;
      if (filterText) {
        var q = filterText.toLowerCase();
        filtered = groups.filter(function (g) { return g.display.toLowerCase().indexOf(q) !== -1; });
      }
      if (countEl) countEl.textContent = filtered.length + ' design' + (filtered.length === 1 ? '' : 's');
      if (!filtered.length) {
        grid.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      grid.innerHTML = filtered.map(function (g) {
        var realIndex = groups.indexOf(g);
        return cardHtml(g, realIndex);
      }).join('');
    }

    function selectGroup(groupIndex) {
      var group = groups[groupIndex];
      var variant = group.variants[0];
      selected = { display: group.display, url: variant.url };
      grid.querySelectorAll('[data-card]').forEach(function (card) {
        card.classList.toggle('is-selected', parseInt(card.getAttribute('data-group-index'), 10) === groupIndex);
      });
      if (banner) {
        banner.classList.add('is-visible');
        if (bannerImg) bannerImg.src = variant.url;
        if (bannerText) bannerText.textContent = 'Selected: ' + group.display;
      }
    }

    if (grid) {
      grid.addEventListener('click', function (e) {
        var zoomBtn = e.target.closest('[data-zoom]');
        var card = e.target.closest('[data-card]');
        if (!card) return;
        var groupIndex = parseInt(card.getAttribute('data-group-index'), 10);

        if (zoomBtn) {
          var groupForZoom = groups[groupIndex];
          var variantForZoom = groupForZoom.variants[0];
          openLightbox(variantForZoom.url, groupForZoom.display, function () {
            selectGroup(groupIndex);
          });
          return;
        }

        selectGroup(groupIndex);
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        renderGrid(searchInput.value.trim());
      });
    }

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.getAttribute('data-pes-tab-btn');
        activeTab = tab;
        tabButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        tabPanels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-pes-tab-panel') === tab);
        });
      });
    });

    if (dataUrl) {
      fetch(dataUrl)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          designs = data;
          groups = groupDesigns(designs);
          renderGrid('');
        })
        .catch(function () {
          if (grid) grid.innerHTML = '<p class="pes-library-empty">Couldn\'t load the design library. Please refresh.</p>';
        });
    }

    if (form) {
      form.addEventListener(
        'submit',
        function (event) {
          if (activeTab !== 'library') {
            removeHiddenInput(form, 'properties[Design]');
            removeHiddenInput(form, 'properties[Design Reference Image]');
            return;
          }
          if (!selected) {
            event.preventDefault();
            event.stopImmediatePropagation();
            alert('Please choose a design from the library, or switch to "Customize Your Own".');
            return;
          }
          setHiddenInput(form, 'properties[Design]', selected.display);
          setHiddenInput(form, 'properties[Design Reference Image]', selected.url);
        },
        true
      );
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-pes-library-root]');
    roots.forEach(initLibrary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
